let probe = null;

function getProbe() {
  if (probe) return probe;

  const canvas = document.createElement('canvas');

  canvas.width = 1;
  canvas.height = 1;
  probe = canvas.getContext('2d', { willReadFrequently: true });

  return probe;
}

/**
 * Resolves any CSS colour (oklch, color-mix, named…) to an [r, g, b] triple by
 * painting one pixel. Canvas gradients interpolate in sRGB and fade to
 * `transparent` through black, so effects need the channels to build their own
 * alpha stops.
 */

export function resolveColor(value, fallback = [255, 255, 255]) {
  const context = getProbe();
  const color = value.trim();

  if (!color) return fallback;

  context.clearRect(0, 0, 1, 1);
  context.fillStyle = `rgb(${fallback.join(' ')})`;
  context.fillStyle = color;
  context.fillRect(0, 0, 1, 1);

  const [r, g, b] = context.getImageData(0, 0, 1, 1).data;

  return [r, g, b];
}

export function rgba([r, g, b], alpha) {
  return `rgb(${r} ${g} ${b} / ${Math.min(Math.max(alpha, 0), 1)})`;
}
